import { CATALOGUE_MODE } from "@constants";

import React, { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";

import { Router } from "@components/Router";

import KioskPreview from "./KioskPreview";

function useIsKioskScreen(): boolean {
    const [isKiosk, setIsKiosk] = useState(
        () => window.innerHeight > window.innerWidth
    );

    useEffect(() => {
        const check = () => {
            setIsKiosk(window.innerHeight > window.innerWidth);
        };
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, []);

    return isKiosk;
}

export function App(): JSX.Element {
    const isKioskScreen = useIsKioskScreen();

    if (process.env.REACT_APP_MODE === CATALOGUE_MODE && !isKioskScreen) {
        return (
            <KioskPreview>
                <Router />
            </KioskPreview>
        );
    }
    return <Router />;
}
